import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import { GlobalAudioPlayerAction, GlobalAudioPlayerActions } from "@/components/GlobalAudioPlayer/types";

export const pauseGlobalPlayer = () => {
  emitter.emit<GlobalAudioPlayerAction>(EVENTS.AUDIO_PLAYER_ACTION, {
    name: GlobalAudioPlayerActions.PAUSE,
  });
};
